<template>
  <div class="credit-card-form-wrapper">
    <Form ref="CreditCardForm" :model="value" :rules="formRules">
      <FormItem label="Name" prop="account_name">
        <Input v-model="value.account_name" class="k-input"/>
      </FormItem>
      <FormItem label="Card number" prop="card_number">
        <Input v-model="value.card_number" class="k-input" v-cardformat:formatCardNumber/>
      </FormItem>
      <Row :gutter="20">
        <i-col :xs="24" :sm="12">
          <FormItem label="Expiry date" prop="expiry_date">
            <Input v-model="value.expiry_date" class="k-input" v-cardformat:formatCardExpiry/>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="12">
          <FormItem label="CVC" prop="cvc">
            <Input v-model="value.cvc" class="k-input" v-cardformat:formatCardCVC/>
          </FormItem>
        </i-col>
      </Row>
    </Form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      formRules: {
        account_name: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        card_number: [
          { required: true, message: 'The card number cannot be empty', trigger: 'blur' }
        ],
        expiry_date: [
          { required: true, message: 'The expiry date cannot be empty', trigger: 'blur' }
        ],
        cvc: [
          { required: true, message: 'The cvc cannot be empty', trigger: 'blur' }
        ]
      }
    }
  },

  methods: {
    handleSubmit () {
      this.$refs.CreditCardForm.validate((valid) => {
        if (valid) {
          this.$emit('success', true)
        } else {
          this.$emit('success', false)
        }
      })
    }
  }
}
</script>
